import React from "react";
import PropTypes from "prop-types";
import merge from "lodash/merge";
import Context from "../../__internal__/i18n-context";
import enGB from "../../locales/en-gb";
export const I18nProvider = ({
  locale,
  children
}) => locale ? /*#__PURE__*/React.createElement(Context.Provider, {
  value: merge({}, enGB, locale)
}, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
export default I18nProvider;